import React, { Component } from "react";
import { Row, Col, Label, Input } from "reactstrap";
import { makeRequestAuth, uploadRequest } from "../../utils/globals";
import ProfileService from "../../services/profileService";
//import Base64 from 'react-native-base64';
import moment from "moment";
//import TemplateModal    from "./TemplateModal";
//import {NotificationManager} from 'react-notifications';
//import ImageLoader          from "../ImageLoader";
import brandlogo from "../../../public/admin/img/svg-icons/poweredbyPlum.svg";
import brandLogo from "../../../public/admin/img/svg-icons/brand-logo-placeholder.svg";
import NewEmailPreview from "../../components/NewEmailPreviewTemplate";
const base64regex =
  /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;

const DEFAULT_FOOTER =
  '<p class="ql-indent-8"><a href="https://www.facebook.com/thexoxoday" rel="noopener noreferrer" target="_blank"><img src="https://res.cloudinary.com/dyyjph6kx/image/upload/v1530602863/webui/eng/emailer-image/fb.png" width="35"></a><a href="https://in.linkedin.com/company/xoxoday" rel="noopener noreferrer" target="_blank"><img src="https://res.cloudinary.com/dyyjph6kx/image/upload/v1530602863/webui/eng/emailer-image/linkdin.png" width="35"></a><a href="https://twitter.com/thexoxoday" rel="noopener noreferrer" target="_blank"><img src="https://res.cloudinary.com/dyyjph6kx/image/upload/v1530602863/webui/eng/emailer-image/tweeter.png" width="35"></a></p><p class="ql-indent-3">You are receiving this email because your Organization has partnered with Xoxoday</p><p class="ql-indent-8"><a href="https://enterprise.xoxoday.com/login" rel="noopener noreferrer" target="_blank"><img src="https://res.cloudinary.com/dyyjph6kx/image/upload/v1530602863/webui/eng/emailer-image/xoxoday-grey-logo.png" height="40"></a></p><p class="ql-indent-7"><a href="mailto: cs@giift.com" rel="noopener noreferrer" target="_blank" style="color: rgb(102, 102, 102);">cs@giift.com</a> | +91 80 6191 5050</p>';

class EmailPreviewIndex extends Component {
  state = {
    editMessage: false,
    templateModal: false,
    templateHover: true,
    logoHover: true,
    editSubject: false,
    editHeading: false,
    cardImages: [],
    loader: false,
    params: {},
    maxLimit: 60,
    selectedTemplate: {},
  };

  componentWillMount = () => {
    this.getEmailPreviewUrl();
  };

  getEmailPreviewUrl = () => {
    let url = window.location.href.split("?");
    //let decodeEmail = Base64.decode(url[1]);
    let decodeEmail = atob(url[1]);
    var regex = /[?&]([^=#]+)=([^&#]*)/g,
      params = {},
      match;
    while ((match = regex.exec(decodeEmail))) {
      params[match[1]] = match[2];
    }
    this.setState({ params: params });
  };

  render() {
    const {
      platformSetting,
      editMessage,
      templateModal,
      templateHover,
      logoHover,
      editHeading,
      editSubject,
      cardImages,
      loader,
      params,
      maxLimit,
      selectedTemplate,
    } = this.state;
    // const {
    //   company_primary_logo,
    //   amountValue, // the amount value of voucher
    //   currencyCode, // currency code of voucher (admin)
    //   receiverName, // the name of recipient
    //   selectedTemplate, // the default template user
    //   site_id,
    //   emailMessgae, // if email message is enabled, this will be value of email message
    //   showEditMessage, // to enable edit message option
    //   emailHeading,
    //   emailSubject,
    //   showEgiftText,
    //   valueText,
    // } = this.props;
    let validTill = moment(new Date()).add(1, "years").format("MMM D, YYYY");
    // let footer =
    //   platformSetting &&
    //   platformSetting.messaging &&
    //   platformSetting.messaging.footerHtml
    //     ? platformSetting.messaging.footerHtml
    //     : JSON.stringify(DEFAULT_FOOTER);
    selectedTemplate.image_url = params.coverImage;
    let reedemBtnTxt = params.redeem_button_text
      ? params.redeem_button_text
      : "Redeem now";
    return (
      <>
        <div className="row mt-5 mb-5">
          <Col>
            <div className="row email-preview  justify-content-center">
              <NewEmailPreview
                useCase="code-distribution"
                validTill={"******"}
                receiverName={params.receipient_name}
                amountValue={
                  params.value && params.currencyCode ? (
                    `${params.value}`
                  ) : (
                    <span>******</span>
                  )
                }
                selectedTemplate={selectedTemplate}
                //updateState={this.updateState}
                site_id={0}
                company_primary_logo={params.primaryLogo}
                currencyCode={params.currencyCode}
                showEditMessage={false}
                emailSubject={params.receipt_subject}
                emailHeading={params.temp_heading}
                showEgiftText={true}
                isEditDisabled={true}
                buttonText={reedemBtnTxt}
              />
            </div>
          </Col>
        </div>
      </>
    );
  }
}

const TemplatePreview = ({ clickHandler, showImage, imgSrc }) => {
  return (
    <div className="voucher-image-preview text-center">
      {!showImage ? (
        <>
          {/*<img
                                            className="voucher-image p-2 mt-5" 
                                            src='/admin/img/svg-icons/edit-image-icon.svg'
                                            style={{cursor: 'pointer'}}
                                            onClick={clickHandler}
                                        />
                                        <p className="message">Image format should be JPG/PNG. Size less than 300 KB (Max.height 150px)</p>*/}
        </>
      ) : (
        <>
          <img
            className="img img-fluid voucher-template-image"
            src={imgSrc ? imgSrc : null}
          />
        </>
      )}
    </div>
  );
};

const LogoPreview = ({ showImage, imgSrc }) => {
  let mainClass = showImage
    ? "logo-image-preview text-center pl-0 pt-0"
    : "logo-image-preview text-center background pl-0 pt-0";
  return (
    <div className={mainClass}>
      {!showImage ? (
        <></>
      ) : (
        <>
          <img
            className="img img-fluid voucher-template-image"
            src={imgSrc ? imgSrc : null}
            style={{
              maxHeight: "77px",
              maxWidth: "100px",
              display: "flex",
              paddingTop: "10px",
            }}
          />
        </>
      )}
    </div>
  );
};

export default EmailPreviewIndex;
